import { render, staticRenderFns } from "./DisposeDivisionHead.vue?vue&type=template&id=25a069b4&scoped=true&"
import script from "./DisposeDivisionHead.vue?vue&type=script&lang=js&"
export * from "./DisposeDivisionHead.vue?vue&type=script&lang=js&"
import style0 from "./DisposeDivisionHead.vue?vue&type=style&index=0&id=25a069b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a069b4",
  null
  
)

export default component.exports